export default [
  {
    path: '/plans/pest/list',
    name: 'plans.pestControl.list',
    component: () => import('@/views/modules/plans/pest-plan/ListPestPlans'),
    meta: {
      module: 'plans.pest',
      pageTitle: 'List All pest control Plans',
      breadcrumb: [
      
        { text: 'Create Plan', to: {name: 'plans.pestControl.create'} }
      ],
    }
  },


  {
    path: '/plans/pest/create',
    name: 'plans.pestControl.create',
    component: () => import('@/views/modules/plans/pest-plan/CreatePestPlan'),
    meta: {
      module: 'plans.pest',
      pageTitle: 'Plan Create',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.pestControl.list'} },
        { text: 'Create Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/pest/:id/edit',
    name: 'plans.pest.edit',
    component: () => import('@/views/modules/plans/pest-plan/EditPestPlan'),
    meta: {
      module: 'plans.pest',
      pageTitle: 'Plan Edit',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.pestControl.list'} },
      
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
